module.exports = __webpack_public_path__ + "img/mercedes-footer.dd141a85.svg";